module.exports = __webpack_public_path__ + "static/img/com1_4.c54e928.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/com1_4.jpg
// module id = CZeZ
// module chunks = 1